/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataBankCardVo } from './PageDataBankCardVo';
import {
    PageDataBankCardVoFromJSON,
    PageDataBankCardVoFromJSONTyped,
    PageDataBankCardVoToJSON,
    PageDataBankCardVoToJSONTyped,
} from './PageDataBankCardVo';

/**
 * 
 * @export
 * @interface ResponsePageDataBankCardVo
 */
export interface ResponsePageDataBankCardVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataBankCardVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataBankCardVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataBankCardVo}
     * @memberof ResponsePageDataBankCardVo
     */
    data?: PageDataBankCardVo;
}

/**
 * Check if a given object implements the ResponsePageDataBankCardVo interface.
 */
export function instanceOfResponsePageDataBankCardVo(value: object): value is ResponsePageDataBankCardVo {
    return true;
}

export function ResponsePageDataBankCardVoFromJSON(json: any): ResponsePageDataBankCardVo {
    return ResponsePageDataBankCardVoFromJSONTyped(json, false);
}

export function ResponsePageDataBankCardVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataBankCardVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataBankCardVoFromJSON(json['data']),
    };
}

export function ResponsePageDataBankCardVoToJSON(json: any): ResponsePageDataBankCardVo {
    return ResponsePageDataBankCardVoToJSONTyped(json, false);
}

export function ResponsePageDataBankCardVoToJSONTyped(value?: ResponsePageDataBankCardVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataBankCardVoToJSON(value['data']),
    };
}

